export enum ManualTaskPlanningStatus {
  Created = "Created",
  ToDo = "ToDo",
  InProgress = "InProgress",
  Completed = "Completed",
  Issue = "Issue",
  Standby = "Standby",
  Canceled = "Canceled",
}
